export class RequestService {
    id = 0;
    description = '';
    category_id:any = '';
    time = '';
    budget = '';
    category = [];
}
